import { Component, OnInit, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';

@Component({
  selector: 'app-rules-and-regulations',
  templateUrl: './rules-and-regulations.component.html',
  styleUrls: ['./rules-and-regulations.component.css']
})
export class RulesAndRegulationsComponent implements OnInit {

  constructor( @Inject(DOCUMENT) private document: Document) {
    this.document.body.classList.add("outer-page");
    this.document.body.classList.remove("inner-page");
  }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/feature/main/roles-shared/components/rules-and-regulations/rules-and-regulations.component.ts